export default {
  BusinessStockDistributionRatioAddSku: {
    title: 'Bin Ratio Allocation Adding',
    supportWarehouseType: 'Supply Warehouse Type:',
    supportWarehouseId: 'Supply Warehouse Name:',
    receiveWarehouseType: 'Receiving Warehouse Type',
    receiveWarehouseId: 'Receiving Warehouse Name',
    spuCode: 'Product Code',
    spuName: 'Product Name',
    categoryId: 'Product Category',
    skuCode: 'SKU Code：',
    supplyWarehouseList: 'Supply Warehouse Product List',
    warehouseType: 'Warehouse Type',
    realPosition: 'Real Warehouse',
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    warehouseStructureRatio: 'Warehouse Structure Ratio Setting',
    distribute: 'Allocation',
    withdraw: 'Withdraw',
    receivingWarehouseList: 'Receiving Warehouse Product List',
    setQty: 'Batch Set',
    setQtyMsg1: 'Please select the receiving warehouse product on the right',
    setQtyMsg2: 'Please enter the bin quantity',
    setQtyMsg3: 'Batch set bin quantity',
    inputErrorMsg: 'Incorrect quantity format',
    errorMsg: 'Cancel Input',
    msgWarning1: 'Please select the supply warehouse product on the left',
    msgWarning2: 'Please select a product first',

    table: {
      categoryName: 'Product Category',
      spuCode: 'SKU',
      spuName: 'Product Name',
      skuCode: 'SKU',
      qty: 'Bin Quantity'
    }
  }
};
